/**
 * Auth API — POST /auth/login (auth-service).
 * Contract verified live 2026-08-01: response is { token, user } —
 * the field is `token`, NOT `access_token`.
 */
import { api } from "../../shared/api/client";
import type { AuthUser } from "./session";

export interface LoginResponse {
  token?: string;
  user?: AuthUser;
  status?: string;
  mfa_required?: boolean;
  enroll_required?: boolean;
  challenge_token?: string;
  pending_approval?: boolean;
  message?: string;
}

export interface MfaEnrollResponse {
  method: "totp";
  secret: string;
  otpauth_uri: string;
  challenge_token: string;
}

export interface MfaVerifyResponse {
  token: string;
  mfa_verified: boolean;
  user?: AuthUser;
}

export function login(username: string, password: string): Promise<LoginResponse> {
  return api.post<LoginResponse>("/auth/login", { username, password });
}

export interface GoogleAuthConfig {
  enabled: boolean;
  client_id: string;
}

export function fetchGoogleAuthConfig(): Promise<GoogleAuthConfig> {
  return api.get<GoogleAuthConfig>("/auth/google/config");
}

export function googleLogin(idToken: string, tenantCode?: string): Promise<LoginResponse> {
  return api.post<LoginResponse>("/auth/google", { id_token: idToken, tenant_code: tenantCode });
}

export function mfaEnroll(challengeToken: string): Promise<MfaEnrollResponse> {
  return api.post<MfaEnrollResponse>("/auth/mfa/enroll", { challenge_token: challengeToken });
}

export function mfaVerify(challengeToken: string, otpCode: string): Promise<MfaVerifyResponse> {
  return api.post<MfaVerifyResponse>("/auth/mfa/verify", { challenge_token: challengeToken, otp_code: otpCode });
}
